import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
import { DASHBOARD_QUERY_KEY } from '../hooks/dashboard/useDashboardData';

// Keeps the last dashboard snapshot in localStorage so a browser reload paints it
// immediately instead of showing skeletons. Only dashboard queries are saved;
// logout's localStorage.clear() removes it along with the session.
export const dashboardPersistOptions = {
  persister: createSyncStoragePersister({
    storage: window.localStorage,
    key: 'automart.dashboard-cache',
  }),
  // The server snapshot never expires either; the quiet sync on mount keeps this copy current.
  maxAge: Infinity,
  // Bump when a dashboard response shape changes so old saved copies are dropped.
  buster: 'dashboard-v1',
  dehydrateOptions: {
    shouldDehydrateQuery: (query) =>
      query.queryKey[0] === DASHBOARD_QUERY_KEY && query.state.status === 'success',
  },
};
